import React from "react";
import { Dumbbell } from "lucide-react";

const GREEN = "#10B981";

// Issue #1128: the drill is drawn as a kit row, not a shadcn Card (the
// legacy-free guard, journey 65, counts `Card`). Same white card-radius box
// the Guides rows use (`LearningHub.jsx` `RowLink`), without the chevron:
// nothing opens from here.
const DRILL_STYLE = {
  background: "var(--nw-surface)",
  border: "1px solid var(--nw-line)",
  borderRadius: "var(--nw-radius-card)",
  padding: "12px 14px",
};

/**
 * Issue #1128 — the kit-row version of `AssignedDrillsList` (#461) for the two-section `/learn`; the shipped list stays for the old look. The drills a coach has written FOR this player, rendered on
 * the Assigned tab of Training & Guides, under the assigned guides.
 *
 * Display-only, deliberately: the list is fetched by the page
 * (`LearningHub.jsx`, the same effect shape as the assigned guides) and
 * this component decides nothing — no API calls, no permissions, no clock.
 *
 * A drill has NO page of its own, unlike a guide: the coach's text IS the
 * content, so the whole body renders here, pre-wrap, on the card. That is
 * also why `coach_drill` notifications land on this tab and why nothing
 * links onward from these cards.
 *
 * Renders nothing at all when there are no drills — the tab's shared empty
 * state ("Nothing assigned yet…") is owned by the page, which shows it
 * only when guides AND drills are both absent.
 */
export default function AssignedDrillsRows({ drills }) {
  if (!drills || drills.length === 0) return null;
  return (
    <div className="space-y-2" data-testid="assigned-drills-list">
      <div className="flex items-center gap-2 text-slate-500 text-sm pt-2">
        <Dumbbell size={14} color={GREEN} /> Drills your coaches have written for you.
      </div>
      {drills.map((d) => (
        <div key={d.assignment_id} style={DRILL_STYLE} data-testid={`assigned-drill-${d.assignment_id}`}>
          <div>
            <div className="font-semibold text-slate-900">{d.title}</div>
            {/* The attribution — the same acceptance criterion as the
                assigned guides' "Assigned by" line (#382). */}
            <div
              className="text-[11px] mt-1 font-medium"
              style={{ color: GREEN }}
              data-testid={`assigned-drill-by-${d.assignment_id}`}
            >
              Assigned by {d.assigned_by_coach_name}
              {fmtWhen(d.assigned_at) && ` · ${fmtWhen(d.assigned_at)}`}
            </div>
            <p className="text-sm text-slate-600 mt-2 whitespace-pre-wrap">{d.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

function fmtWhen(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-NZ");
}
